import script from "./TextDictionary.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextDictionary.vue?vue&type=script&lang=ts&setup=true"

import "./TextDictionary.vue?vue&type=style&index=0&id=e2c46744&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c46744"]])

export default __exports__